import HomeAd from "assets/anim/home.json";
import NetworkStatus from "components/network-status";
import SearchBox from "components/search-box";
import Lottie from "lottie-react";
import { Outlet } from "react-router-dom";
import TransactionChart from "views/home/components/TransactionChart";

export default function HomeLayout() {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back h-[403px] md:h-[320px]"></div>
      <div className="container">
        <div className="relative px-2.5 md:px-3 lg:px-5">
          <div className="grid grid-cols-12 items-center pt-6 md:gap-12 md:py-5">
            <div className="col-span-12 py-1 md:col-span-9 md:py-2 xl:col-span-8">
              <p className="text-header mb-3 text-white">
                Explore BBA Blockchain
              </p>
              <SearchBox
                className="mt-4"
                placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
              />
              <div className="flex justify-center md:hidden">
                <Lottie
                  animationData={HomeAd}
                  loop={true}
                  style={{ width: "205px", height: "205px" }}
                />
              </div>
            </div>
            <div className="hidden h-full justify-center xl:col-span-4 xl:flex">
              <Lottie
                animationData={HomeAd}
                loop={true}
                style={{ width: "205px", height: "205px" }}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 px-2.5 md:px-3 lg:px-5 xl:grid-cols-3 xl:gap-5">
          <NetworkStatus />

          <div className="box z-10 overflow-hidden">
            <TransactionChart />
          </div>
        </div>

        <Outlet />
      </div>
    </div>
  );
}
